"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MetaSpirituality = void 0;
const GlobalEventName_1 = require("../GlobalEventName");
const PartyName_1 = require("../../parties/PartyName");
const MetaSpiritualityDeferredAction_1 = require("../../../deferredActions/MetaSpiritualityDeferredAction");
class MetaSpirituality {
    constructor() {
        this.name = GlobalEventName_1.GlobalEventName.META_SPIRITUALITY;
        this.description = 'Gain 1 standard resource for each card with no tags (no limit) and influence. Each resource must be different if possible.';
        this.revealedDelegate = PartyName_1.PartyName.SPOME;
        this.currentDelegate = PartyName_1.PartyName.TRANSHUMANS;
    }
    resolve(game, turmoil) {
        game.getPlayers().forEach((player) => {
            const amount = player.getNoTagsCount() + turmoil.getPlayerInfluence(player);
            if (amount > 0) {
                game.defer(new MetaSpiritualityDeferredAction_1.MetaSpiritualityDeferredAction(player, amount));
            }
        });
    }
}
exports.MetaSpirituality = MetaSpirituality;
//# sourceMappingURL=MetaSpirituality.js.map